
import EmptyAdsImage from '@/media/MultiAgentsHome/emptyAdsImage.png';
import React from 'react';
import * as Styles from './AccountWithoutAds.styles';
import useLocale from '@/hooks/useLocale';
import {
  Button, IconMegaphone,
} from 'gatorcomponents';

const AccountWithoutAds = ({
  handleOpenGator,
}) => {
  const { marketing: marketingLocale } = useLocale();
  const { multiAgentScreens: multiAgentScreensLocale } = marketingLocale;
  const { withoutAds: withoutAdsLocale } = multiAgentScreensLocale;

  const handleClick = () => {
    handleOpenGator && handleOpenGator({
      message: withoutAdsLocale.ctaMessage,
    });
  };

  return (
    <>
      <Styles.StyledContainer>
        <Styles.Content>
          <Styles.Image src={EmptyAdsImage} />

          <Styles.SecondTitle>
            {withoutAdsLocale.secondTitle}
          </Styles.SecondTitle>

          <Styles.Description>
            {withoutAdsLocale.description}
          </Styles.Description>

          <Styles.ButtonWrapper>
            <Button
              iconLeft={<IconMegaphone color="highPure" />}
              label={withoutAdsLocale.cta}
              size="large"
              notFillSVG
              onClick={handleClick}
            />
          </Styles.ButtonWrapper>
        </Styles.Content>
      </Styles.StyledContainer>
    </>
  );
};

export default AccountWithoutAds;
